import { useState } from "react";
import { useTranslation } from "react-i18next";
import { CommonUtils } from "@utils/CommonUtils";

export interface UnexpectedErrorPageProps {
    error: Error;
    errorInfo: React.ErrorInfo;
}

function useUnexpectedErrorPage(props: UnexpectedErrorPageProps) {
    const { t } = useTranslation();
    const [showDetails, setShowDetails] = useState(false);

    const state = { showDetails };

    const handlers = {
        toggleDetails: () => setShowDetails(prev => !prev),
        handleRefresh: () => window.location.reload(),
        handleGoHome: () => { window.location.href = `/${CommonUtils.getLng()}`; },
    };

    const utilities = {
        t,
        errorMessage: `${props.error.name}: ${props.error.message}`,
        stackTrace: props.error.stack ?? "",
        componentStack: props.errorInfo.componentStack ?? "",
    };

    return { state, handlers, utilities };
}

export default useUnexpectedErrorPage;
